export default __webpack_public_path__ + "static/media/magnite-logo.16deb59a.svg";